import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceProviderService } from '../../../services/service-provider.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DisputeStorageService } from '../../../services/create-dispute-storage.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-create-dispute-invoice-info',
  templateUrl: './create-dispute-invoice-info.component.html',
  styleUrls: ['./create-dispute-invoice-info.component.css'],
})

export class CreateDisputeInvoiceInfoComponent implements OnInit {

  @Output() selectSection = new EventEmitter<any>();

  disputeData: any;
  itemData: any;
  itemCADocumentNumber: any;
  invoiceStatus: any;
  disputeForm!: FormGroup;
  amount: any = 0.00;
  currency!: string;
  iId!: string;
  itemNumber: string = "0";
  bpNo: any;
  type: any;
  section1: boolean = true;
  section2: boolean = false;
  dr: any;
  submitted: boolean = false;
  DisputeTypeMap!: Map<String, String>;
  selectedReason: string | undefined;
  DisputeReasonMap!: Map<String, String>;
  DisputePriority!: Map<String, String>;
  selectedPriority!: string;
  selectedDisputeType!: string;
  formData: FormData = new FormData();
  fileName: String = "";
  private subscription: Subscription = new Subscription();
  isInvoiceDispute: boolean = true;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private spService: ServiceProviderService,
    private router: Router,
    private route: ActivatedRoute,
    @Inject(DisputeStorageService) private disputeStorageService: DisputeStorageService
  ) {
    this.disputeForm = this.fb.group({
      amount: new FormControl('', Validators.required),
      type: new FormControl('', Validators.required),
      priority: new FormControl('', Validators.required),
      reason: new FormControl('', Validators.required),
      note: new FormControl('', Validators.required),
      // iNumber: new FormControl(this.iId, Validators.required),
      itemNumber: '',
      file: new FormControl(null),
    });

  }

  ngOnInit(): void {
    // this.sleep(1000)
    this.getDisputeConfig();
    let disputeType = localStorage.getItem('dispute-type') || ''   
    this.isInvoiceDispute = (disputeType == 'invoice-level-dispute') ? true : false;

    if(this.isInvoiceDispute){
      this.disputeForm.addControl(
        'iNumber',
        new FormControl(this.iId, Validators.required)
      );
      this.disputeData = JSON.parse(localStorage.getItem('selected-invoice-to-dispute') || '') || history.state.invoice;
      let disputeType = localStorage.getItem('selected-type-to-dispute') || history.state.type;
      if (disputeType == 'invoice') {
        this.iId = this.disputeData.invoice_id;
        this.amount = parseFloat(this.disputeData.amount).toFixed(2);
        this.currency = this.disputeData.currency;
      } else if (disputeType == 'item') {
        this.itemData = JSON.parse(localStorage.getItem('selected-item-to-dispute') || '') || history.state.item;;
        this.itemNumber = this.itemData.itemNo
        this.iId = this.disputeData.invoice_id
        this.amount = parseFloat(this.itemData.itemCAAmountInTransactionCurrency).toFixed(2);
        this.currency = this.itemData.itemTransactionCurrency;
      }
    }
    else{
      this.disputeData = JSON.parse(localStorage.getItem('ban-data-to-dispute') || '') || history.state.banData;
      this.currency = this.disputeData.currency;
    }

    this.subscription.add(
      this.disputeStorageService.disputeFormState$.subscribe((storedValues) => {
        if (storedValues) {
          this.populateForm(storedValues);
        }
      })
    );

    // Sync initial state with storage service
    this.disputeStorageService.updateDisputeFormState(this.disputeForm.value);

    // Listen to form changes and sync with the store
    this.disputeForm.valueChanges.subscribe((formValues) => {
      this.disputeStorageService.updateDisputeFormState(formValues);
    });
  }

  // Populate form with values from the store
  private populateForm(storedValues: any): void {
    this.disputeForm.patchValue(storedValues);
    this.selectedDisputeType = storedValues.typeValue;
    this.selectedReason = storedValues.reasonValue;
    this.selectedPriority = storedValues.priorityValue;
    this.fileName = storedValues.fileName;
    if(!this.isInvoiceDispute || (this.isInvoiceDispute && storedValues.isAmountUpdated)){
      this.amount = storedValues.amount
    }
  }

  // Unsubscribe to prevent memory leaks
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  sleep(ms: any) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  get f(): { [key: string]: AbstractControl } {
    return this.disputeForm.controls;
  }

  getDisputeConfig() {
    this.spService.getDisputeConfig().subscribe((res: any) => {
      if (this.isInvoiceDispute) {
        this.DisputeTypeMap = res.disputeTypeMap;
      } else {
        const excludedTypes = ["Incorrect Credit", "Incorrect Invoice"];
        const filteredDisputeTypeMap = Object.entries(res.disputeTypeMap)
          .filter(([label]) => !excludedTypes.includes(label))
          .reduce((obj: any, [label, code]) => {
            obj[label] = code;
            return obj;
          }, {} as Record<string, string>);
          this.DisputeTypeMap = filteredDisputeTypeMap;
      }
      this.DisputeReasonMap = res.disputeReasonMap;
      this.DisputePriority = res.disputePriorityMap;
    })
  }

  closeDisputePopup() {
    this.modalService.dismissAll();
    this.router.navigate(["view-my-dispute"], { relativeTo: this.route.parent });
  }

  saveDispute() {
    this.submitted = true;
    if (this.disputeForm.invalid) {
      return;
    }
    this.selectSection.emit('dispute-summary')
  }

  formatAmount(): void {
    const amountControl = this.disputeForm.get('amount');
    if (amountControl) {
      const value = parseFloat(amountControl.value).toFixed(2);
      if (value != "NaN") {
        amountControl.setValue(value, { emitEvent: false });
        this.disputeStorageService.updateDisputeFormState({ isAmountUpdated: true });
        this.disputeStorageService.updateDisputeFormState({ amount: value });
      }
    }
  }

  selectReason(reason: any, value: any): void {
    this.disputeForm.get('reason')?.setValue(value);
    this.selectedReason = reason;
    this.disputeStorageService.updateDisputeFormState({ reason: value });
    this.disputeStorageService.updateDisputeFormState({ reasonValue: reason });
  }

  selectPriority(priority: any, value: any): void {
    this.disputeForm.get('priority')?.setValue(value);
    this.selectedPriority = priority;
    this.disputeStorageService.updateDisputeFormState({ priority: value });
    this.disputeStorageService.updateDisputeFormState({ priorityValue: priority });
  }

  selectDisputeType(type: any, value: any): void {
    this.disputeForm.get('type')?.setValue(value);
    this.selectedDisputeType = type;
    this.disputeStorageService.updateDisputeFormState({ type: value });
    this.disputeStorageService.updateDisputeFormState({ typeValue: type });
  }

  fileChange(event: any): void {
    const fileList: FileList = event.target.files;
    if (fileList.length < 1) {
      return;
    }
    const file: File = fileList[0];
    this.formData.append('file', file, file.name);
    this.fileName = file.name;
    this.disputeStorageService.updateDisputeFormState({ fileName: file.name });
    this.disputeStorageService.updateDisputeFormState({ file: file });
  }
}
